export default ({ config = [], extensions = [] }) => extensions.some(extension => config.includes(extension))